import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from '../MaintenanceReportCategories';
import { Layout } from '@singularsystems/neo-canvas-grid';
import { Neo } from '@singularsystems/neo-react';
import SecurityHoldingsDataExtractReportCriteria from '../SecurityHoldingsDataExtract/SecurityHoldingsDataExtractReportCriteria';
import { AppService, Types } from '../../../App/Services/AppService';
import { TextConstants } from '../../../Common/TextConstants';


@NeoReport("SecurityHoldingsDataExtract", { category: MaintenanceReportCategories.DataExtractReports})
export default class SecurityHoldingsDataExtractReport extends Report<SecurityHoldingsDataExtractReportCriteria>{

    constructor(
        public serviceProviderApiClient = AppService.get(Types.ApiClients.ServiceProviderApiClient),
        public clientAccountApiClient = AppService.get(Types.ApiClients.ClientAccountApiClient),
        public instrumentApiClient = AppService.get(Types.ApiClients.InstrumentApiClient)
    ) {
        super(SecurityHoldingsDataExtractReportCriteria);
    }

    public renderCriteria() {
        return <React.Fragment>
            <Neo.GridLayout lg={4}>
                <Neo.FormGroup bindContext={this.criteria.meta.staticServiceProviderFileGroupingId} label={TextConstants.Labels.Broker}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria}
                        bind={this.criteria.meta.staticServiceProviderFileGroupingId}
                        bindDisplay={this.criteria.meta.serviceProviderGroupingName}
                        displayMember={"serviceProviderGroupingName"}
                        items={this.serviceProviderApiClient.getServiceProviderFileGroupingListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                        .sort((x,y) => x.serviceProviderGroupingName.localeCompare(y.serviceProviderGroupingName)))}
                        />
                </Neo.FormGroup>
                <Neo.FormGroup
                    appendText="fa-calendar"
                    bind={this.criteria.meta.date}
                    label={TextConstants.Labels.ReportingDate}
                    />
                <Neo.FormGroup bindContext={this.criteria.meta.clientAccountId} label={TextConstants.Labels.BrokerAccountCode}>
                    <Neo.AutoCompleteDropDown
                        itemSource={(searchCriteria) => this.clientAccountApiClient.getClientAccountNumbersListByCriteria(searchCriteria, this.criteria.meta.staticServiceProviderFileGroupingId.value)}
                        bind={this.criteria.meta.clientAccountId}
                        bindDisplay={this.criteria.meta.brokerAccountNumber}
                        displayMember={"serviceProviderAccountNumber"}
                        items={this.clientAccountApiClient.getClientAccountNumbersListByCriteria(" ", this.criteria.meta.staticServiceProviderFileGroupingId.value).then((arr) => arr.data.slice(0, 10)
                        .sort((x, y) => x.serviceProviderAccountNumber.localeCompare(y.serviceProviderAccountNumber)))}
                        />
                </Neo.FormGroup>
                <Neo.FormGroup bindContext={this.criteria.meta.staticInstrumentId} label={TextConstants.Labels.Instrument}>
                    <Neo.AutoCompleteDropDown
                        itemSource={this.instrumentApiClient.getInstrumentLookupListByCriteria}
                        bind={this.criteria.meta.staticInstrumentId}
                        bindDisplay={this.criteria.meta.instrumentDisplayName}
                        displayMember={"description"}
                        items={this.instrumentApiClient.getInstrumentLookupListByCriteria(" ").then((arr) => arr.data.slice(0, 10)
                        .sort((x, y) => x.ticker!.localeCompare(y.ticker!)))}
                    />
                </Neo.FormGroup>
            </Neo.GridLayout>
        </React.Fragment>
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}